import React, { Component } from 'react'
import { get } from 'lodash'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import RangeSlider from '../../atoms/RangeSlider'
import RangeSliderLabel from '../../atoms/RangeSliderLabel'
import { getValueTextFormatter, getAriaLabels } from '../../../helpers/getAriaAttributesForSlider'

const propTypes = {
  filterName: PropTypes.string,
  filters: PropTypes.arrayOf(PropTypes.object),
  handleChange: PropTypes.func,
  filterNamePrefix: PropTypes.string,
  handleAfterChange: PropTypes.func,
  className: PropTypes.string,
}

const SliderCategoryGroupStatelessWrapper = styled.div``

class SliderCategoryGroupStateless extends Component {
  constructor(props) {
    super(props)
    this.filter = this.props.filters[0]
    this._handleChange = this.handleChange.bind(this)
    this._handleAfterChange = this.handleAfterChange.bind(this)
  }

  handleChange(value) {
    if (this.filter.oneWay) {
      this.props.handleChange({ [this.props.filterNamePrefix]: [value] })
    } else {
      this.props.handleChange({ [this.props.filterNamePrefix]: value })
    }
  }

  handleAfterChange(value) {
    if (this.filter.oneWay) {
      this.props.handleAfterChange({ [this.props.filterNamePrefix]: [value] })
    } else {
      this.props.handleAfterChange({ [this.props.filterNamePrefix]: value })
    }
  }

  render() {
    const defaultMin = this.filter.defaultValueArray[0] || this.filter.min
    const defaultMax = this.filter.defaultValueArray[1] || this.filter.max
    const value =
      get(this, 'props.filters[0].value') || (this.filter.oneWay ? [defaultMin] : [defaultMin, defaultMax])
    const valueTextFormatter = getValueTextFormatter(this.filter)
    const ariaLabels = getAriaLabels(this.filter, this.props.filterName)

    return (
      <SliderCategoryGroupStatelessWrapper>
        <RangeSliderLabel
          formatByTime={this.filter.formatByTime}
          formatByDuration={this.filter.formatByDuration}
          currencySymbol={this.filter.currencySymbol}
          minSelected={value[0]}
          maxSelected={value[1]}
          absMax={this.filter.max}
          absMin={this.filter.min}
          plusSymbol={this.filter.plusSymbol}
          sliderName={this.filter.filterNamePrefix}
          sliderIcon={this.filter.sliderIcon}
          isMilitaryTime={this.filter.isMilitaryTime}
        />
        <RangeSlider
          data-testid='RANGE_SLIDER'
          oneWay={this.filter.oneWay}
          defaultValueArray={this.filter.defaultValueArray}
          value={value}
          min={this.filter.min}
          max={this.filter.max}
          handleChange={this._handleChange}
          handleAfterChange={this._handleAfterChange}
          disabled={this.filter.disabled}
          step={this.filter.step}
          ariaLabelGroupForHandles={this.filter.ariaLabelGroupForHandles || ariaLabels}
          ariaLabelledByGroupForHandles={this.filter.ariaLabelledByGroupForHandles}
          ariaValueTextFormattersForHandles={
            this.filter.ariaValueTextFormattersForHandles || [valueTextFormatter, valueTextFormatter]
          }
          ariaLabelForHandle={this.filter.ariaLabelForHandle || ariaLabels[0]}
          ariaLabelledByForHandle={this.filter.ariaLabelledByForHandle}
          ariaValueTextFormatterForHandle={this.filter.ariaValueTextFormatterForHandle || valueTextFormatter}
        />
      </SliderCategoryGroupStatelessWrapper>
    )
  }
}

SliderCategoryGroupStateless.propTypes = propTypes

export default SliderCategoryGroupStateless
